module.exports = __webpack_public_path__ + "static/media/balance-f.abe63c5e.svg";